import Request from './request'

export default class uploadService {
  static async uploadImage(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Upload/uploadMediaFile',
        data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ issSuccess: true, data })
        } else {
          return resolve({ issSuccess: false })
        }
      })
    })
  }
  static async userCheckCriminal(data = {},token=undefined) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/CustomerCriminalRecord/user/userCheckCriminalFromVr',
        data,
        token:token
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async uploadImageImport(data = {} , cancelEvent) {
    return new Promise((resolve) => {
      Request.sendImportExport({
        method: 'POST',
        path: '/Upload/uploadMediaFile',
        data,
        cancelEvent
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ issSuccess: true, data })
        } else {
          return resolve({ issSuccess: false })
        }
      })
    })
  }

  static async uploadImageBanner(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Upload/uploadAdMediaFile',
        data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ issSuccess: true, data })
        } else {
          return resolve({ issSuccess: false })
        }
      })
    })
  }

  static async importDataCustomers(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/CustomerRecord/importExcel',
        data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve({})
        }
      })
    })
  }

  static async updateStationIntroduction(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/StationIntroduction/updateStationIntro',
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ issSuccess: true })
        } else {
          return resolve({ issSuccess: false })
        }
      })
    })
  }

  static async updateBanner(path, data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: path,
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ issSuccess: true })
        } else {
          return resolve({ issSuccess: false })
        }
      })
    })
  }

  static async getCrimeRecords(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/CustomerCriminalRecord/user/getCrimeRecords',
        data
      }).then((result = {}) => {
        const { statusCode, data, error } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true, data:data })
        } else {
          return resolve({ isSuccess: false })
        }
      })
    })
  }
}
